import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mprd-norton360-my-account',
  templateUrl: './norton360-my-account.component.html',
  styleUrls: ['./norton360-my-account.component.css'],
})
export class Norton360MyAccountComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
